export function scmCommandCode(
  targetBranchShortHash: string,
  featureBranchShortHash: string,
  path?: string
) {
  const command = targetBranchShortHash
    ? `git fetch\ngit diff ${targetBranchShortHash}...${featureBranchShortHash}${
        path ? ` -- ${path}` : ''
      }`
    : `git fetch\ngit diff ${targetBranchShortHash}${
        path ? ` -- ${path}` : ''
      }`;
  return command;
}
